<template>
  <div class="body">
    <!-- <div class="is-pay">品牌名称为您提供高品质服务</div> -->
    <div class="doc-box">
      <div class="doc-cont" v-if="doctorinfo">
        <div class="dis-doc-left">
          <div class="item-expert">
            <p class="expert-avar" @click="handleDoctorDetail">
              <img :src="doctorinfo?doctorinfo.avatar:''" class="all-i" alt />
            </p>
          </div>
        </div>
        <div class="expert-info">
          <div class="item-expert font-85">
            <p class="expert-info-doctor">
              <span class="expert-name">{{doctorinfo?doctorinfo.zname:''}}</span>
            </p>
          </div>
          <div class="pay-tags">
            <div class="pay-tag">
              100%医生本人
            </div>
            <div class="pay-tag">
              12小时必回
            </div>
            <div class="pay-tag">
              未回复可退款
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="border-card">
      <h3 class="font-85">请选择您要为谁问诊</h3>
      <div
        class="pat-card patient-box"
        :class="{active:pid==item.id}"
        v-for="(item,index) in patList"
        :key="index"
        @click="changePat(item.id)"
      >
        <p class="font-85">{{item.realname}}</p>
        <p class="pat-ages font-65">
          <i class="icon icon-pat-male" :class="{'icon-pat-female':item.sex==2}"></i>
          {{item.sex==1?'男':'女'}} {{item.age}}岁
        </p>
      </div>
      <div class="pat-card add-card" v-if="patList.length<6" @click="addPat">
        <i class="icon icon-pat-add"></i>
        <div class="pat-ages pat-ages-add">添加就诊人</div>
      </div>
      <br class="clear" />
      <h3 class="font-85">病情描述</h3>
      <textarea class="miaoshu" placeholder="请输入描述" maxlength="500" v-model="description"></textarea>
      <p class="yinsi"><i class="order-yinsi"></i>大医健康为您保障隐私，内容仅医生可见</p>
    </div>

    <div class="border-card" style="padding-bottom: 1rem;">
      <h3 class="font-85">服务类型</h3>
      <div class="leixing-box">
        <i class="leixing-icon" :class="{'phone':payType==2,'tuwen':payType==1,'shipin':payType==3}"></i>
        <div>
          <p v-if="payType==1">图文咨询 <span>￥{{paymoney}}</span></p>
          <p v-if="payType==2">电话咨询 <span>￥{{paymoney}}</span></p>
          <p v-if="payType==3">视频问诊 <span>￥{{paymoney}}</span></p>
          <span v-if="payType==1">在线开方、药材快递到家</span>
          <span v-if="payType==2">10分钟通话时长、在线开方、药材快递到家</span>
          <span v-if="payType==3">10分钟视频咨询、在线开方、药材快递到家</span>
        </div>
      </div>
    </div>
    <div class="border-card" style="padding-bottom: 1rem;">
      <div class="pay-btn" @click="pay">微信支付</div>
    </div>
    <div class="mask" v-if="paying"></div>
  </div>
</template>

<script>
import http from "../../request/http";
import {getCustomerPhone} from '../../utils/index';
export default {
  name: "wenzhen_order_pay",
  data() {
    return {
      doctorinfo: null,
      docid: "",
      payType: 0,
      paymoney: "",
      pid: "",
      daojiu: "",
      paying:false,
      patList: [],
      doctorid: "",
      service_type:0,
      description:''
    };
  },
  created(){
    let docid = this.$route.query.doctorid;
    this.docid = docid;
    if(this.$route.query.type){
      this.payType = this.$route.query.type;
    }
    this.docInfo(docid);
  },
  filters:{
    moneyToFixed(val){
      if(val){
        return (val/100).toFixed(2);
      }else{
        return '0.00';
      }
    }
  },
  mounted() {
    this.pid = this.$route.query.patid;
    this.loadPat()
  },
  methods: {
    handleDoctorDetail(){
      this.$router.push('/doctor_main?doctorid='+this.docid)
    },
    changePat(pid){
      this.pid = pid
    },
    handlePdf(type){
      let pdf = ''
      if(type == 1){
        pdf = 'user_register_protocol.pdf'
      }else if(type == 2){
        pdf = 'legal_notice.pdf'
      }
      this.$router.push({
        name:'pdf_template',
        query:{
          pdf:pdf
        }
      })
    },
    addPat() {
      this.$router.push({
        name: "patient_edit",
        query: {
          from: "wenzhen_order_pay",
          type: this.$route.query.type,
          doctorid: this.$route.query.doctorid,
        },
      });
    },
    handleCall(){
      if(this.$cookies.get('customer_phone')){
        window.location.href = `tel:${this.$cookies.get('customer_phone')}`
      }else{
        getCustomerPhone(this,(phone) => {
          window.location.href = `tel:${phone}`
        });
      }
    },
    docInfo(id) {
      http.post("/api/wap/doctor/info", { doctorId: id })
        .then((res) => {
          this.doctorinfo = res.data[0];
          if(this.payType == 1){
            this.paymoney = (res.data[0].graphic_money / 100).toFixed(2);
          }else if(this.payType == 2){
            this.paymoney = (res.data[0].phone_money/100).toFixed(2);
          }else if(this.payType == 3){
            this.paymoney = (res.data[0].video_money/100).toFixed(2);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadPat() {
      console.log(111);
      http.post("/api/wap/user/patientlist").then((res) => {
        console.log(res);
        this.patList = res.data;
        this.pid = res.data[0].id;
      });
    },
    selectType(money, type) {
      if(type == 1){
        if(this.doctorinfo.is_graphic == 0){
          this.paymoney = (money/100).toFixed(2);
          this.payType = type;
        }else{
          this.paymoney = 0.00;
          this.payType = 0;
        }
      }else if(type == 2){
        if(this.doctorinfo.is_phone == 0){
          this.paymoney = (money/100).toFixed(2);
          this.payType = type;
        }else{
          this.paymoney = 0.00;
          this.payType = 0;
        }
      }
    },
    pay() {
      if(this.description == ""){
        this.$toast.center('请填写病情描述');
        return;
      }else if(this.pid == 0){
        this.$toast.center('请选择就诊人');
        return;
      }
      this.paying = true;
      http.post("/api/wap/order/fucreate", {
          doctor_id: this.docid,
          pid: this.pid,
          currency: "cny",
          channel: "wx_pub",
          type: this.payType,
          description:this.description,
          classes_id:this.$route.query.classesid,
          class_time_id:this.$route.query.classtimeid
        })
        .then((res) => {
          if (res.errno == 0) {
            let pingpp = require("pingpp-js");
            pingpp.createPayment(res.data.charge, (result, err) => {

              if (result == "success") {
                // 只有微信公众账号 (wx_pub)、微信小程序 (wx_lite)、QQ 公众号 (qpay_pub)、支付宝口碑 (alipay_qr)
                // 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
                this.$toast.center("支付成功");
                this.paying = false;
                this.$router.push({
                  name: "chat",
                  query: {
                    doctorid: this.docid,
                    pid:this.pid,
                    name:this.doctorinfo.zname
                  },
                });
              } else if (result == "fail") {
                // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
                this.$toast.center('支付异常，请重试');
                this.paying = false;
                console.log("wx_pub fail");
              } else if (result == "cancel") {
                // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
                this.$toast.center('取消支付');
                this.paying = false;
              }
            });
          } else {
            this.$toast.center(res.errmsg);
            this.paying = false;
            if(res.errno == 50002 && res.errmsg.indexOf('请勿重复购买') != -1){
              setTimeout(() => {
                this.$router.push({
                  name:'chat',
                  query:{
                    doctorid:this.doctorinfo.id,
                    pid:this.pid,
                    name:this.doctorinfo.zname
                  }
                })
              },500)
            }else if(res.errno == 50002 && res.errmsg.indexOf('请先支付未付款订单') != -1){
              setTimeout(() => {
                this.$router.push({
                  name:'my_issue'
                })
              },500)
            }
          }
        }).catch(err => {
          this.paying = false;
          console.log(err)
        })
    },
  },
};
</script>

<style scoped>
.body {
  padding: 0;
  padding-bottom: 0.5rem;
}
.solgin {
  width: 100%;
  height: 4rem;
}
.expert-avar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}
.is-pay {
  text-align: center;
  display: block;
  font-size: 0.9rem;
  font-weight: 700;
}
.doc-cont {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.7rem;
}
.doc-box {
  height: 4.5rem;
  padding: 0.5rem;
  padding-top: 1rem;
  background: #fff;
  border-bottom: 1px solid rgba(0,0,0,0.09);
}

.expert-name {
  font-size: 1rem;
  font-weight: 700;
  height: 1.3rem;
  line-height: 1.3rem;
}
.expert-pos {
  font-size: 0.8rem;
  height: 1.3rem;
  line-height: 1.3rem;
}
.expert-info-good {
  font-size: 0.8rem;
  padding:0;
  height: 1.2rem;
  line-height: 1.2rem;
  margin-top: 0.25rem;
}
.pay-tags {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.pay-tag {
  height: 1rem;
  background: #FFFBF4;
  color: #FAAD14;
  text-align: center;
  font-size: 0.6rem;
  line-height: 1rem;
  border-radius: 0.15rem;
  padding: 0 0.1rem;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
}
.icon-pay-tag {
  content: url("../../../static/icons/true@2x.png");
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.15rem;
}
.pay-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pay-card-head h3 {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.85);
  position: relative;
  padding-left: 0.4rem;
  height: 1.25rem;
  line-height: 1.25rem;
}
.pay-card-head h3::before {
  content: "";
  display: block;
  width: 0.15rem;
  height: 0.8rem;
  border-radius: 0.05rem;
  background-color: rgba(24, 144, 255, 1);
  position: absolute;
  top:0.2rem;
  left: 0;
}
.card-price {
  font-size: 0.9rem;
  color: #fa541c;
  font-weight: 700;
}
.icon-big {
  width: 2rem;
  height: 2rem;
}
.icon-jiaoliu {
  content: url("../../../static/icons/news@3x.png");
}
.icon-kaifang {
  content: url("../../../static/icons/kaifang@3x.png");
}
.icon-daodi {
  content: url("../../../static/icons/shunfeng@3x.png");
}
.icon-goutong {
  content: url("../../../static/icons/call@3x.png");
}
.liu-bg {
  width: 100%;
  height: 1rem;
  margin-bottom: 4.3rem;
  border-bottom: 0.05rem dashed rgba(0, 0, 0, 0.25);
  margin-top: 1.2rem;
  position: relative;
}
.is-phone{
  margin-top: 1.7rem;
}
.liucheng {
  font-size: 0.7rem;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1rem;
  z-index: 9;
  position: absolute;
  top: 0;
  left: 0;
}
.liu-bg::after {
  content: "";
  display: inline-block;
  width: 3rem;
  height: 0.05rem;
  position: absolute;
  left: 0;
  bottom: -0.05rem;
  background: #fff;
  z-index: 1;
  clear: both;
}
.liu-bg::before {
  content: "";
  display: inline-block;
  width: 3rem;
  height: 0.05rem;
  position: absolute;
  right: 0;
  bottom: -0.05rem;
  background: #fff;
  z-index: 1;
  clear: both;
}
.liucheng-item {
  background: #fff;
}
.border-card ul {
  padding-left: 0.8rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 1rem;
  line-height: 1.1rem;
  text-align: justify;
}
.border-card ul li{
  list-style: none;
  position: relative;
}
.border-card ul li::before{
  content: '';
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background-color: rgba(197, 197, 197, 1);
  position: absolute;
  top:0.4rem;
  left: -0.8rem;
}
.border-card{
  border-radius: 0;
}
.card-1{
  height: 9.45rem;
  border:0.1rem solid rgba(255,255,255,1);
}
.card-1.active{
  border:0.1rem solid rgba(24, 144, 255, 1);
}
.card-2{
  padding-bottom: 1.85rem;
}
.kefu{
  width: 2.3rem;
  padding:0;
  padding-right: 0.5rem;
  margin-right: 0.5rem;
  box-sizing: border-box;
}
.card-price-close{
  color: rgba(0, 0, 0, 0.25);
}
.border-card h3{
  margin-bottom: 0;
}
.dis-doc-left{
  width: 2.5rem;
  height: 2.5rem;
  margin-top: -0.175rem;
}
.expert-info-doctor{
  line-height: 1.4rem;
  margin-bottom: 0.2rem;
}
.content{
  padding-top: 0.65rem;
}
.border-card h3{
  font-size: 0.9rem;
  line-height: 1;
  margin-bottom: 1rem;
}
.patient-box p{
  height: 1.4rem;
  line-height: 1.4rem;
  font-size: 1rem;
  margin-bottom: 0.2rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-pat-male{
  content: url(data:image/png;base64,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);
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 0.3rem;
}
.patient-box.active{
  background-color: rgba(24, 144, 255, 0.05);
  border: 0.05rem solid rgba(24, 144, 255, 1);
}
.patient-box .pat-ages, .pat-card .pat-ages-add{
  height: 1.2rem;
  line-height: 1.2rem;
  margin-bottom: 0;
}
.icon-pat-add{
  content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAAEi6oPRAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAASKADAAQAAAABAAAASAAAAACQMUbvAAABaUlEQVR4Ae3ZUY6CMBhF4eJq2P9q2I2GRJKmlpxKS/Mbz7zMyC1QPq7V0ZT8uU9g27ZnefRHuaH22EE1lc9tNeByVJNluVPtcbwDLS3XX7uUS9taThbPaNiM0Gz3+XOjYdgeCOuW5j37bXaykA2F5CE8Il9B13VdeI/zEcNu2vkpvkucEHkppBAJUD7vhZFm8s7DlbprVT0u2pX6kJjxO1yHnBDddoVIqHsdGrkG7ZP1ltEtU0ghEqDcDilEApTbIYVIgHI7REL+K01C4Trke+qfu2XhOuSE7BAJUG6HFCIByu2QQiRAeff7ITpBS55/TpmP7/2GOz/W1b/DPcmuXshd+wkEsgIJBAIQ2yCBQABiGyQQCEBsgwQCAYhtkEAgALENEggEILZBABTuK02Y7/TYBgG5QADkR64AZIMEAgGIbZBAIACxDRIIBCC2QQKBAMQ2SCAQgNgGCQQCENsggUAAYhskEAhA/AIfPEM8mVbmPAAAAABJRU5ErkJggg==);
  width: 1.2rem;
  height: 1.2rem;
  margin-bottom: 0.3rem;
  vertical-align: top;
}
.pat-card{
  width: 8rem;
  height: 4.4rem;
}

.add-card{
  text-align: center;
  padding: 0.8rem 0.8rem 0.9rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.icon-pat-female{
  content: url(data:image/png;base64,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);
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 0.3rem;
}
.pat-card p.pat-ages{
  font-size: 0.8rem;
  font-weight: 400;
  margin: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
  .miaoshu{
    width: 100%;
    height: 5.6rem;
    border-radius: 0.25rem;
    background: #FAFAFA;
    padding: 0.7rem 0.8rem;
    font-size: 0.8rem;
    border: none;
    outline: none;
    resize: none;
  }
  .yinsi{
    line-height: 2.2rem;
    font-size: 0.6rem;
    color: rgba(0,0,0,0.25);
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .order-yinsi{
    content: '';
    display: block;
    width: 0.55rem;
    height: 0.6rem;
    background: url("../../../static/icons/dunpai.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 0.5rem;
  }
  .leixing-box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .leixing-box>div p{
    color: rgba(0,0,0,0.85);
    font-size: 0.8rem;
    font-weight: 700;
  }
.leixing-box>div p span{
  color: #FA541C;
  font-size: 0.8rem;
  margin-left: 0.8rem;
}
.leixing-box>div>span{
  color: rgba(0,0,0,0.45);
  font-size: 0.65rem;
}
  .leixing-icon{
    content: '';
    display: block;
    width: 2rem;
    height: 2rem;
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 1rem;
  }
.leixing-icon.phone{
  background-image: url("../../../static/icons/dianhua@3x.png");
}
.leixing-icon.tuwen{
  background-image: url("../../../static/icons/tuwen@3x.png");
}
.leixing-icon.shipin{
  background-image: url("../../../static/icons/shipin@3x.png");
}
.border-card:last-child{
  margin:0;
}
.item-expert{
  width: 100%;
  height: 100%;
}
.all-i{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/wenzhen_order_pay.vue